import { useContext } from 'react';

import { AddSingleQuestionConditionsContext } from './add-single-question-conditions-provider';

export function useAddSingleQuestionConditions() {
  const context = useContext(AddSingleQuestionConditionsContext);

  if (!context) {
    throw new Error(
      'useAddSingleQuestionConditions must be used within an AddSingleQuestionConditionsProvider',
    );
  }

  return context;
}
